import { useMemo } from 'react';

import useSiteInfo from '@fo-hooks/common/useSiteInfo';

/**
 * siteNumber 에 따른 컴포넌트 반환 훅
 *
 * @param {*} defaultPage : React.ComponentType
 * @param {*} sitePageMap : { "SiteNumber": React.ComponentType } 키가 siteNumber, 벨류가 컴포넌트인 오브젝트
 * @param isEventMall : boolean 이벤트몰 여부
 * @param eventMallPage : object
 * @returns React.ComponentType
 */
export function useSiteComponentResolver(defaultPage, sitePageMap, isEventMall = false, eventMallPage) {
  const { siteNumber } = useSiteInfo();

  return useMemo(() => {
    if (isEventMall && !Object.hasOwn(sitePageMap, siteNumber)) {
      return eventMallPage;
    } else {
      return sitePageMap[siteNumber] ?? defaultPage;
    }
  }, [defaultPage, isEventMall, eventMallPage, siteNumber, sitePageMap]);
}
